<div class="pb-6 text-4xl leading-none font-extrabold tracking-tight">{{ title() }}</div>
<div class="flex flex-col gap-12">
  <aura-password-confirm-edit
    [(isEditing)]="isEditingPassword"
    [isAllowedToEdit]="isAllowedToEditPassword()"
    (passwordSaved)="savePassword($event)"
    [lastUpdateAt]="$safeNavigationMigration(currentUser()?.metadata?.credentials?.lastUpdateAt)"
  />
  @if (userSessions(); as userSessions) {
    <core-user-sessions
      [userSessions]="userSessions"
      (revokeSession)="revokeSession($event)"
      (revokeAllSession)="revokeAllSessions()"
    />
  }
  @if (currentUser(); as user) {
    <core-deactivate-account (deactivateAccount)="openDeactivateAccountFlow()" />
  }
</div>
